export default "__VITE_ASSET__Bbp4lRWb__"